<template>
  <div class="account">
    <div class="flex-column">
      <div class="card-grid">
        <card-component
          v-for="card in computedCardArr"
          :key="card.title"
          class="card-component"
          :check-icon="card.checkIcon"
          :display-green-check="card.displayGreenCheck"
        >
          <template #icon>
            <component :is="card.icon"></component>
          </template>
          <template #title>
            {{ card.title }}
          </template>

          <component
            :is="card.component"
            @toggle="toggleAddressModal"
          ></component>
        </card-component>
      </div>
      <div class="card-flex bottom-buttons">
        <div class="settings">
          <locale-changer class="lang-dropdown" />
        </div>
        <div class="right-buttons">
          <!-- <button
            v-if="showWatermark"
            class="account-button first"
            @click="removeWatermark"
          >
            <BubbleIcon />
            {{ $t("account.removeWatermark") }}
          </button>
          <button
            class="account-button second"
            :class="{ first: !showWatermark }"
            @click="opeChangePassword"
          >
            <PasswordIcon />{{
              user.user.hasPassword
                ? $t("account.updatePassword")
                : $t("account.setPassword")
            }}
          </button>
          <button
            v-if="user.user.hasPassword"
            class="account-button third"
            @click="logOut"
          >
            <LogOutIcon />{{ $t("account.logOut") }}
          </button>
          <button class="account-button fourth" @click="toggleDeleteModal">
            <TrashIcon />{{ $t("account.deleteAccount") }}
          </button> -->
          <button
            class="account-button"
            @click="showAccountOptionsModal = true"
          >
            <PenIcon class="button-icon" />{{
              $t("account.userInformation.bottomButtons.accountOptions")
            }}
          </button>
          <button
            class="account-button"
            @click="showPasswordOptionsModal = true"
          >
            <SettingsIcon class="button-icon" />{{
              $t("account.userInformation.bottomButtons.passwordAccess")
            }}
          </button>
        </div>
      </div>
    </div>
    <address-modal v-if="showAddressModal" @close="toggleAddressModal" />
    <ChangePassword v-if="showChangePassword" @close="closeChangePassword" />
    <delete-account-modal v-if="showDeleteModal" @close="toggleDeleteModal" />
    <PlanRegistration
      v-if="showUpgradeModal"
      :new-plan="growthPlan"
      @close="closeUpgradeModal"
    />
    <!-- <div
      v-if="displayPicker"
      key="color-picker"
      v-click-outside="hidePicker"
      class="vidjet-color-picker"
    >
      <colorPicker
        :value="currentColor"
        @input="onPickerChange($event, pickerType)"
      />
    </div> -->
    <AccountOptionsModal
      v-if="showAccountOptionsModal"
      :disable-localization="isBasicOrAppsumoUser"
      @close-options-modal="showAccountOptionsModal = false"
      @open-localization="openLocalizationModal"
      @open-default-colors-picker="openDefaultColorsPicker"
      @remove-watermark="removeWatermark"
    />
    <DefaultColorsPickerModal
      v-if="showDefaultColorsPicker"
      @close="showDefaultColorsPicker = false"
    />
    <PasswordOptionsModal
      v-if="showPasswordOptionsModal"
      @close-options-modal="showPasswordOptionsModal = false"
      @open-change-password="opeChangePassword"
      @log-out="logOut"
      @cancel-subscription="toggleDeleteModal"
    />
    <AddLocalizationModal
      v-if="showLocalizationModal"
      @close="showLocalizationModal = false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import LocaleChanger from "../LocaleChanger.vue";
import UserInformation from "./settings-components/UserInformation";
import CompanyInformation from "./settings-components/CompanyInformation";
import Usage from "./settings-components/Usage";
import Password from "./settings-components/Password";
import AddressModal from "./settings-components/AddressModal";
import DeleteAccountModal from "./settings-components/DeleteAccountModal";
import CardComponent from "@/components/shared/CardComponent.vue";
import ChangePassword from "@/components/settings/ChangePassword.vue";
import PlanRegistration from "@/components/upgrade-plan/PlanRegistration.vue";
import AccountOptionsModal from "./settings-components/AccountOptionsModal.vue";
import PasswordOptionsModal from "./settings-components/PasswordOptionsModal.vue";
import DefaultColorsPickerModal from "./settings-components/DefaultColorsPickerModal.vue";
import AddLocalizationModal from "./settings-components/AddLocalizationModal.vue";

import UserIcon from "@/assets/svg/settings/user-info.svg?inline";
import CompanyIcon from "@/assets/svg/settings/company-info.svg?inline";
import UsageIcon from "@/assets/svg/settings/usage.svg?inline";
import PasswordIcon from "@/assets/svg/settings/password.svg?inline";
import BubbleIcon from "@/assets/svg/settings/bubble-icon.svg?inline";
import LogOutIcon from "@/assets/svg/settings/log-out-icon.svg?inline";
import TrashIcon from "@/assets/svg/delete.svg?inline";
import PenIcon from "@/assets/svg/pen-icon.svg?inline";
import SettingsIcon from "@/assets/svg/settings-icon.svg?inline";

import { Chrome } from "vue-color";

export default {
  components: {
    UserInformation,
    CompanyInformation,
    Usage,
    Password,
    AddressModal,
    DeleteAccountModal,
    LocaleChanger,
    CardComponent,
    UserIcon,
    CompanyIcon,
    UsageIcon,
    PasswordIcon,
    BubbleIcon,
    LogOutIcon,
    TrashIcon,
    ChangePassword,
    PlanRegistration,
    colorPicker: Chrome,
    PenIcon,
    SettingsIcon,
    AccountOptionsModal,
    PasswordOptionsModal,
    DefaultColorsPickerModal,
    AddLocalizationModal,
  },

  data() {
    return {
      showAddressModal: false,
      showDeleteModal: false,
      showChangePassword: false,
      showUpgradeModal: false,
      mainColorValue: "#7B01B5",
      textColorValue: "#FFFFFF",
      displayPicker: false,
      pickerType: "",
      showAccountOptionsModal: false,
      showPasswordOptionsModal: false,
      showDefaultColorsPicker: false,
      showLocalizationModal: false,
    };
  },
  computed: {
    ...mapState(["user", "plan", "usage", "site"]),
    ...mapGetters({
      userHasInfo: "user/userHasInfo",
      siteHasInfo: "site/siteHasInfo",
      userIsTrial: "plan/userIsTrial",
      currentPlan: "plan/currentPlan",
      currentPricing: "plan/currentPricing",
      showWatermark: "plan/showWatermark",
      videoViewsLimit: "plan/videoViewsLimit",
      videosInCampaignsLimit: "plan/videosInCampaignsLimit",
      numberOfVideosInLibrary: "video/numberOfVideosInLibrary",
    }),

    computedCardArr() {
      return [
        {
          checkIcon: true,
          displayGreenCheck: this.userHasInfo && this.siteHasInfo,
          icon: "UserIcon",
          title: this.$t("account.userInformation.title"),
          component: "UserInformation",
        },
        {
          checkIcon: true,
          displayGreenCheck: !this.userHasReachedUsageLimit,
          icon: "UsageIcon",
          title: this.$t("account.usage.title"),
          component: "Usage",
        },
      ];
    },
    userHasReachedUsageLimit() {
      if (!this.videoViewsLimit && !this.videosInCampaignsLimit) return false;

      if (this.usage.usage.videoViews >= this.videoViewsLimit) return true;

      if (this.numberOfVideosInLibrary >= this.videosInCampaignsLimit)
        return true;

      return false;
    },
    growthPlan() {
      return (
        this.plan.plan.pricings.find((pricing) => pricing.name === "growth") ||
        null
      );
    },
    currentColor() {
      return this.pickerType === "main"
        ? this.mainColorValue
        : this.textColorValue;
    },
    isAppsumoUser() {
      if (this.currentPlan) {
        return this.currentPlan.includes("tier");
      } else return false;
    },
    isBasicOrAppsumoUser() {
      if (
        this.$store.state.account.user.siteId === '1d2d1cd7-08c0-40f3-aa2e-76aace0748a2' ||
        this.$store.state.account.user.siteId === '0cbd3754-81cb-4508-af9a-a71edb819b63' // sauvai.com
      ) return false;

      return (
        this.isAppsumoUser ||
        this.currentPlan === "free" ||
        this.currentPlan === "starter"
      );
    },
  },

  async created() {
    await this.$store.dispatch("plan/getPlan", {
      siteId: this.$store.state.account.user.siteId,
    });
    this.mainColorValue = this.site?.site?.mainColor || "#7B01B5";
    this.textColorValue = this.site?.site?.textColor || "#FFFFFF";
  },

  methods: {
    toggleAddressModal() {
      this.showAddressModal = !this.showAddressModal;
    },
    toggleDeleteModal() {
      this.showPasswordOptionsModal = false;
      this.showDeleteModal = !this.showDeleteModal;
    },
    async removeWatermark() {
      if (
        (!this.currentPlan ||
          this.currentPlan === "free" ||
          this.currentPlan === "starter") &&
        !(this.currentPlan === "custom" && this.currentPricing?.cost === 25)
      ) {
        this.showUpgradeModal = true;
      } else {
        try {
          await this.$store.dispatch("plan/removeWatermark", {
            siteId: this.$store.state.account.user.siteId,
          });
          this.$notify({
            title: this.$t("shared.toastMessage.success"),
            text: this.$t("shared.toastMessage.watermarkRemoved"),
            type: "success",
          });
          this.showAccountOptionsModal = false;
        } catch (err) {
          console.log(err);
          this.$notify({
            title: this.$t("shared.toastMessage.error"),
            text: err,
            type: "error",
          });
        }
      }
    },
    opeChangePassword() {
      this.showPasswordOptionsModal = false;
      this.showChangePassword = true;
    },
    closeChangePassword() {
      this.showChangePassword = false;
    },
    async logOut() {
      try {
        await this.$store.dispatch("account/logout");
        this.$notify({
          title: this.$t("shared.toastMessage.success"),
          text: this.$t("shared.toastMessage.logoutSuccess"),
          type: "success",
        });
        this.$router.push({ name: "login" });
      } catch (err) {
        console.log(err);
        this.$notify({
          title: this.$t("shared.toastMessage.error"),
          text: this.$t("shared.toastMessage.logoutError"),
          type: "error",
        });
      }
    },
    closeUpgradeModal() {
      this.showUpgradeModal = false;
    },
    showPicker(type) {
      this.pickerType = type;
      this.displayPicker = true;
    },
    hidePicker() {
      this.displayPicker = false;
    },
    onPickerChange(color) {
      const hex = color.hex;
      if (this.pickerType === "main") {
        this.mainColorValue = hex;
        this.updateSiteColor("mainColor", hex);
      } else if (this.pickerType === "text") {
        this.textColorValue = hex;
        this.updateSiteColor("textColor", hex);
      }
    },

    async updateSiteColor(key, value) {
      try {
        await this.$store.dispatch("site/updateSite", {
          siteId: this.site.site._id,
          dataToUpdate: {
            [key]: value,
          },
        });
      } catch (e) {
        console.error(e);
      }
    },
    openDefaultColorsPicker() {
      this.showAccountOptionsModal = false;
      this.showDefaultColorsPicker = true;
    },
    openLocalizationModal() {
      this.showAccountOptionsModal = false;
      this.showLocalizationModal = true;
    },
  },
};
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
.account {
  margin: 0 auto;
}
.card-grid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.card-component {
  width: 100%;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
}

.right-buttons {
  display: flex;
  gap: 24px;
}

.account-button {
  @include base-font;
  @include font-small;
  font-weight: 500;
  color: $dark-purple;
  display: flex;
  gap: 8px;
  align-items: center;
  height: 34px;
  border: 1px solid $dark-purple;
  background-color: white;
  padding: 8px 16px;
  border-radius: 4px;
  &:hover {
    color: white;
    background-color: $dark-purple;
    .button-icon {
      path {
        fill: white;
      }
    }
  }
}

.first {
  border-radius: 3px 0 0 3px;
  border-right: none;
}
.fourth {
  border-radius: 0 3px 3px 0;
  border-right: 1px solid $medium-grey;
}

@include media(">tablet", "<=desktop") {
  .card-flex {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }

  .main-content-wrapper {
    margin: 0 auto;
    margin-left: calc(73px + 16px);
    margin-right: 16px;
    padding: 0;
  }
}

@include media("<tablet") {
  .card-flex {
    grid-template-columns: 1fr;
  }
}
.settings {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.setting {
  display: flex;
  gap: 8px;
  align-items: center;
  p {
    @include base-font;
    @include font-small;
  }
}

.color-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-code {
  border: 1px solid $medium-grey;
  padding: 8px 16px;
  background: transparent;
  @include base-font;
  @include font-smaller;
  color: $medium-grey;
  border-radius: 2px;
  outline: none;
  width: 90px;
  box-sizing: border-box;
}

.value-color {
  margin: 0;
}
</style>
